export enum SearchType {
  HOME_FLIGHT = 'HOME_FLIGHT',
  HOME_HOTELS = 'HOME_HOTELS',
  HOME_BUSES = 'HOME_BUSES',
  HOME_AUTOS = 'HOME_AUTOS',
  HOME_BYHOURS = 'HOME_BYHOURS',
  BUSES_RESULTS = 'BUSES_RESULTS',
  FLIGHT_RESULTS = 'FLIGHT_RESULTS',
  HOTELS_RESULTS = 'HOTELS_RESULTS',
  BYHOURS_RESULTS = 'BYHOURS_RESULTS',
  HOTELS_DETAIL = 'HOTELS_DETAIL',
  BYHOURS_DETAIL = 'BYHOURS_DETAIL',
  FLIGHT_USER_HISTORY = 'FLIGHT_USER_HISTORY',
  PACKAGES_RESULT = 'PACKAGES_RESULT',
  PACKAGES_HOME = 'PACKAGES_HOME',
  AUTOS_RESULTS = 'AUTOS_RESULTS',
  AUTOS_DETAIL = 'AUTOS_DETAIL',
  ALERT = 'ALERT',
  TOUR_AND_ACTIVITIES = 'TOUR_AND_ACTIVITIES',
}

export enum SearchParamFromType {
  RECENT = 'recent'
}
